namespace Ir.Components.Email.ScheduledEmailEditor {
    interface IViewModel {
        dataGridOptions: DevExpress.ui.dxDataGrid.Properties;
        dataGridComponent: DevExpress.ui.dxDataGrid;
        dataGridFormEditComponent: DevExpress.ui.dxForm;
        formDetailsComponent: DevExpress.ui.dxForm;

        formOptions: DevExpress.ui.dxForm.Properties;
        saveReportsMessage: KnockoutObservable<boolean>;
        currentEmail: KnockoutObservable<ScheduledEmail>;
    }
    interface IParams {
        result: ScheduledEmailResultVM
    }

    let popupComponent: DevExpress.ui.dxPopup;
    export function getViewModel(this: IViewModel, params: IParams) {
        let formatList;
        let self = this;

        let store = new DevExpress.data.CustomStore({
            key: "id",
            load: function (loadOptions) {
                return params.result.emails;
            },
            insert: function (values: any) {
                validateSchedule(values);

                var d = $.Deferred();

                irGlobal.updateFromServer(null,
                    urlConfigs.email + "SaveEmail",
                    values,
                    function (data) {
                        copyIds(data, values);
                        values.dateAdded = data.dateAdded;
                        d.resolve(values);
                    },
                    function (textStatus, errorThrown, errorItem: IError) {
                        errorItem.userMessage = "Failed to save scheduled email";
                        irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                    },
                    true,
                    "POST",
                    true);

                params.result.emails.push(values);

                return d.promise();
            },
            update: function (key, values) {
                let d = $.Deferred();
                let url = urlConfigs.email + "SaveEmail";
                if (!isEditingInPopupMode(self)) {
                    url = urlConfigs.email + "SaveSendEmail";
                }

                let scheduleEmail = params.result.emails.find(x => x.id === key);
                if (scheduleEmail) {
                    copyProperties(values, scheduleEmail);
                    validateSchedule(scheduleEmail);

                    if (params.result.emailsManagement) {
                        if (scheduleEmail.scheduledDays && scheduleEmail.scheduledDays.length > 0) {
                            scheduleEmail.scheduledDaysFilter = scheduleEmail.scheduledDays.map(x => "#" + x + "#").toString();
                        }
                        else {
                            scheduleEmail.scheduledDaysFilter = "";
                        }
                    }

                    irGlobal.updateFromServer(null,
                        url,
                        scheduleEmail,
                        function (data) {
                            copyIds(data, scheduleEmail);
                        },
                        function (textStatus, errorThrown, errorItem: IError) {
                            errorItem.userMessage = "Failed to save scheduled email";
                            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                        },
                        true,
                        "POST",
                        true);
                    self.currentEmail(scheduleEmail);
                }

                d.resolve();
                return d.promise();
            },
            remove: function (key) {
                var d = $.Deferred();

                irGlobal.updateFromServer(null,
                    urlConfigs.email + "DeleteEmail",
                    { userReportID: key },
                    null,
                    function (textStatus, errorThrown, errorItem: IError) {
                        errorItem.userMessage = "Failed to delete scheduled email";
                        irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                    },
                    true,
                    "POST",
                    true);

                let filtered = params.result.emails.filter(x => x.id !== key);
                params.result.emails = filtered;

                d.resolve();
                return d.promise();
            }
        });

        let refreshByCode = false;
        let newRow = false;

        this.currentEmail = ko.observable(params.result.emails.length > 0 ? params.result.emails[0] : null);

        this.saveReportsMessage = ko.observable(params.result.tabs ? params.result.tabs.filter(function (x) { return x.id < 0; }).length > 0 : false);
        this.dataGridOptions = {
            headerFilter: {
                visible: params.result.emailsManagement ? true : false,
                search: { enabled: params.result.emailsManagement ? true : false }
            },
            height: "calc(100% - 281px)",
            dataSource: store,
            showColumnLines: false,
            showRowLines: true,
            rowAlternationEnabled: false,
            selection: {
                mode: params.result.emailsManagement ? 'multiple' : 'none',
                showCheckBoxesMode: 'always'
            },
            searchPanel: {
                visible: params.result.emailsManagement,
                placeholder: 'Search...',
                searchVisibleColumnsOnly: true
            },
            paging: {
                enabled: false
            },
            columns: [
                { dataField: 'scheduledDaysFilter', visible: false },
                {
                    dataField: "id",
                    visible: false,
                },
                {
                    dataField: 'workbookName',
                    caption: 'Workbook',
                    visible: params.result.emailsManagement ? true : false
                },
                {
                    dataField: "recipients",
                    caption: "Email",
                    validationRules: [{
                        type: "custom",
                        validationCallback: function (v) {
                            //if you are not editing with the popup open, it does not validate
                            if (!isEditingInPopupMode(self)) {
                                return true;
                            }

                            if (v.data.useAddressList) {
                                return true;
                            }

                            if (v.value === undefined || v.value === null) {
                                return false;
                            }

                            if (v.value.trim() === "") {
                                return false;
                            }

                            return true;
                        },
                        message: "Email is required"
                    }, {
                        type: "custom",
                        message: "Invalid email",
                        validationCallback: function (e) {
                            const value = e.value;
                            if (e.data.useAddressList) {
                                return true;
                            }

                            if (e.value === undefined || e.value === null) {
                                return false;
                            }

                            if (e.value.trim() === "") {
                                return false;
                            }

                            //.filter(Boolean) remove empty strings
                            const emails = value.split(/[,;]+/).map(email => email.trim()).filter(Boolean);

                            return emails.every(isValidEmail);
                        }
                    }]
                },
                {
                    dataField: "cc",
                    caption: "CC",
                    visible: false,
                    validationRules: [{
                        type: "custom",
                        message: "Invalid email",
                        validationCallback: function (e) {
                            const value = e.value;
                            if (e.data.useAddressList) {
                                return true;
                            }

                            if (e.value === undefined || e.value === null) {
                                return true;
                            }

                            if (e.value.trim() === "") {
                                return true;
                            }

                            //.filter(Boolean) remove empty strings
                            const emails = value.split(/[,;]+/).map(email => email.trim()).filter(Boolean);

                            return emails.every(isValidEmail);
                        }
                    }],
                },
                {
                    dataField: "bcc",
                    caption: "BCC",
                    visible: false,
                    validationRules: [{
                        type: "custom",
                        message: "Invalid email",
                        validationCallback: function (e) {
                            const value = e.value;
                            if (e.data.useAddressList) {
                                return true;
                            }

                            if (e.value === undefined || e.value === null) {
                                return true;
                            }

                            if (e.value.trim() === "") {
                                return true;
                            }

                            //.filter(Boolean) remove empty strings
                            const emails = value.split(/[,;]+/).map(email => email.trim()).filter(Boolean);

                            return emails.every(isValidEmail);
                        }
                    }],
                },
                {
                    caption: 'Address List',
                    dataField: 'addressListId',
                    lookup: {
                        dataSource: params.result.addressLists,
                        displayExpr: 'name',
                        valueExpr: 'id',
                    },
                    visible: true,
                    validationRules: [{
                        type: "custom",
                        validationCallback: function (v) {
                            //if you are not editing with the popup open, it does not validate
                            if (!isEditingInPopupMode(self)) {
                                return true;
                            }

                            if (!v.data.useAddressList) {
                                return true;
                            }

                            if (v.value === undefined || v.value === null || v.value === 0) {
                                return false;
                            }

                            return true;
                        },
                        message: "Address List is required"
                    }],
                    setCellValue: function (newData, value, currentRowData: ScheduledEmail) {
                        let addressList = params.result.addressLists.find(x => x.id === value);
                        newData.filterId = addressList?.getFilterId(currentRowData.mappingId) ?? null;

                        this.defaultSetCellValue(newData, value, currentRowData);
                    },
                },
                {
                    dataField: "subjectText",
                    caption: "Subject",
                    validationRules: [{ type: 'required' }],
                },
                {
                    dataField: 'userName',
                    caption: 'User',
                },
                {
                    dataField: 'userId',
                    caption: 'User',
                    width: 150,
                    lookup: {
                        dataSource: [],
                        displayExpr: 'name',
                        valueExpr: 'id',
                    },
                    validationRules: [{ type: 'required' }],
                    setCellValue: function (newData, value, currentRowData) {
                        const user = (self.dataGridComponent as any).usersGroups.find(x => x.id === value);
                        newData.userName = user?.name;

                        this.defaultSetCellValue(newData, value, currentRowData);
                    },
                    visible: false
                },
                {
                    dataField: 'scope',
                    caption: 'Scope',
                    width: 85,
                    lookup: {
                        dataSource: [
                            { id: ContainerScopeEnum.Workbook, name: "Workbook" },
                            { id: ContainerScopeEnum.Report, name: "Report" },
                            { id: ContainerScopeEnum.Dashboard, name: "Dashboard" }
                        ],
                        displayExpr: 'name',
                        valueExpr: 'id',
                    },
                    validationRules: [{ type: 'required' }]
                },
                {
                    dataField: 'sendEmptyReport',
                    caption: 'Send Empty Report',
                    width: 85,
                    lookup: {
                        dataSource: [{ id: 0, name: "Yes" }, { id: 1, name: "No" }, { id: 2, name: "Notification" }],
                        displayExpr: 'name',
                        valueExpr: 'id',
                    },
                    setCellValue: function (newData, value, currentRowData) {
                        this.defaultSetCellValue(newData, value, currentRowData);
                    },
                    visible: false
                },
                {
                    dataField: 'widgetIdEmptyReport',
                    caption: 'Check Empty with',
                    visible: false,
                    lookup: {
                        dataSource: [],
                        displayExpr: 'name',
                        valueExpr: 'id',
                    },
                    setCellValue: function (newData, value, currentRowData) {
                        this.defaultSetCellValue(newData, value, currentRowData);
                    },
                    validationRules: [{
                        type: "custom",
                        validationCallback: function (v) {
                            //if you are not editing with the popup open, it does not validate
                            if (!isEditingInPopupMode(self)) {
                                return true;
                            }

                            if (v.data.sendEmptyReport === SendEmptyReportEnum.Yes || v.data.scope !== ContainerScopeEnum.Dashboard) {
                                return true;
                            }

                            if (v.value === undefined || v.value === null || v.value === 0) {
                                return false;
                            }

                            return true;
                        },
                        message: "Widget is required"
                    }]
                },
                {
                    dataField: 'notificationText',
                    caption: 'Notification Text',
                    visible: false,
                    setCellValue: function (newData, value, currentRowData) {
                        this.defaultSetCellValue(newData, value, currentRowData);
                    },
                    validationRules: [{
                        type: "custom",
                        validationCallback: function (v) {
                            //if you are not editing with the popup open, it does not validate
                            if (!isEditingInPopupMode(self)) {
                                return true;
                            }

                            if (v.data.sendEmptyReport !== SendEmptyReportEnum.Notification) {
                                return true;
                            }

                            if (v.value === undefined || v.value === null) {
                                return false;
                            }

                            if (v.value.trim() === "") {
                                return false;
                            }

                            return true;
                        },
                        message: "Notification Text is required"
                    }]
                },
                {
                    dataField: 'pdfTemplateId',
                    caption: 'PDF Template',
                    lookup: {
                        dataSource(options) {
                            return {
                                store: params.result.pdfTemplates || [],
                                filter: options.data ? irSettings.multiTenant ? 
                                    [
                                        [
                                            [
                                                ['companyId', '=', options.data.companyId],
                                                'or',
                                                [['companyId', '=', 0], 'and', ['organisationId', '=', 0]],
                                                'or',
                                                [['companyId', '=', 0], 'and', ['organisationId', '=', options.data.organisationId]]                                            
                                            ],
                                            'and',
                                            [
                                                ['mappingId', '=', options.data.mappingId],
                                                'or',
                                                ['mappingId', '=', 0]
                                            ]
                                        ],
                                        'or',
                                        ['id', '=', 0]
                                    ] : [['mappingId', '=', options.data.mappingId], 'or', ['mappingId', '=', 0], 'or', ['id', '=', 0]]
                                    : null,
                            };
                        },
                        displayExpr: 'name',
                        valueExpr: 'id',
                    },
                    visible: false,
                    setCellValue: function (newData, value, currentRowData) {
                        this.defaultSetCellValue(newData, value, currentRowData);
                        if (value !== 0) {
                            newData.suppressReportHeader = false;
                        }
                    }
                },
                {
                    dataField: 'suppressReportHeader',
                    caption: 'Suppress Report Header',
                    visible: false,
                    editorType: 'dxSwitch' as any,
                    setCellValue: function (newData, value, currentRowData) {
                        this.defaultSetCellValue(newData, value, currentRowData);
                        if (value) {
                            newData.pdfTemplateId = 0;
                        }
                    }
                },
                {
                    dataField: 'formats',
                    caption: 'Format',
                    width: 70,
                    lookup: {
                        dataSource: getFormats(),
                        displayExpr: 'name',
                        valueExpr: 'id',
                    },
                    setCellValue: function (newData, value, currentRowData) {
                        this.defaultSetCellValue(newData, value, currentRowData);

                        if (value !== EmailFormatEnum.PDF && value !== EmailFormatEnum.PDFLandscape) {
                            newData.pdfTemplateId = 0;
                        }
                    },
                    validationRules: [{ type: 'required' }, {
                        type: "custom",
                        validationCallback: function (v) {
                            //if you are not editing with the popup open, it does not validate
                            if (!isEditingInPopupMode(self)) {
                                return true;
                            }

                            let scheduledEmail: ScheduledEmail = v.data;
                            if (v.value === EmailFormatEnum.Image || v.value === EmailFormatEnum.EmailBody) {
                                let tab: ScheduledEmailTabVM = (self.dataGridComponent as any).tabs.find(t => t.id === scheduledEmail.tabId)
                                if (!irSettings.emailBodyHTML || !tab) {
                                    return false;
                                }

                                if (v.value === EmailFormatEnum.EmailBody && tab.reportType !== "Analysis") {
                                    return false;
                                }
                            }

                            return true;
                        },
                        message: "Invalid Format with this type of report"
                    }]
                },
                {
                    dataField: 'tabName',
                    caption: 'Tab',
                },
                {
                    dataField: 'tabId',
                    caption: 'Tab',
                    width: 160,
                    lookup: {
                        dataSource: [],
                        displayExpr: 'name',
                        valueExpr: 'id',
                    },
                    setCellValue: function (newData, value, currentRowData) {
                        const tab: ScheduledEmailTabVM = (self.dataGridComponent as any).tabs.find(x => x.id === value);

                        if (value === 0)
                            newData.scope = ContainerScopeEnum.Workbook;
                        else {
                            newData.scope = tab.type === "Dashboard" ? ContainerScopeEnum.Dashboard : ContainerScopeEnum.Report;
                        }

                        newData.tabName = tab?.name;

                        let formats = getColumnValue("formats", self.dataGridComponent);
                        if (newData.scope !== ContainerScopeEnum.Report && (formats === EmailFormatEnum.EmailBody || formats === EmailFormatEnum.Excel || formats === EmailFormatEnum.CSV || formats === EmailFormatEnum.ExcelWithoutHeaders || formats === EmailFormatEnum.CSVWithoutHeaders)) {
                            newData.formats = EmailFormatEnum.PDF;
                        }

                        if (newData.scope === ContainerScopeEnum.Workbook && formats === EmailFormatEnum.Image) {
                            newData.formats = EmailFormatEnum.PDF;
                        }

                        if (formats === EmailFormatEnum.EmailBody && newData.scope === ContainerScopeEnum.Report) {
                            if (!tab || (tab && tab.reportType !== "Analysis")) {
                                newData.formats = EmailFormatEnum.PDF;
                            }
                        }

                        newData.widgetIdEmptyReport = 0;

                        this.defaultSetCellValue(newData, value, currentRowData);
                    },
                    visible: false
                },
                { dataField: 'bodyText', visible: false, },
                {
                    dataField: 'schedule',
                    visible: false,
                    setCellValue: function (newData, value, currentRowData) {
                        newData.scheduledDays = [];
                        this.defaultSetCellValue(newData, value, currentRowData);
                    }
                },
                {
                    dataField: 'scheduledDays',
                    visible: false,
                    validationRules: [{
                        type: "custom",
                        validationCallback: function (v) {
                            //if you are not editing with the popup open, it does not validate
                            if (!isEditingInPopupMode(self)) {
                                return true;
                            }

                            if (v.data.schedule !== ScheduledTypeEnum.Daily && v.value.length === 0) {
                                return false;
                            }

                            if (v.data.schedule === ScheduledTypeEnum.Monthly && v.data.scheduledOnDayOrdinalNumber !== ScheduledOrdinalDayEnum.SpecificDays) {
                                return false;
                            }

                            return true;
                        },
                        message: "Scheduled Days is required"
                    }],
                },
                {
                    dataField: 'multipleHours', visible: false,
                    setCellValue: function (newData, value, currentRowData) {
                        this.defaultSetCellValue(newData, value, currentRowData);
                    }
                },
                { dataField: 'scheduledHour', visible: false, },
                {
                    dataField: 'scheduledHours', visible: false,
                    validationRules: [{
                        type: "custom",
                        validationCallback: function (v) {
                            //if you are not editing with the popup open, it does not validate
                            if (!isEditingInPopupMode(self)) {
                                return true;
                            }

                            if (v.data.multipleHours && v.value.length === 0) {
                                return false;
                            }
                            return true;
                        },
                        message: "Scheduled Hours is required"
                    }]
                },
                {
                    dataField: 'scheduledEveryMonths',
                    visible: false,
                    lookup: {
                        dataSource: Array.from({ length: 12 }, (_, i) => i + 1),
                    },
                },
                {
                    dataField: 'scheduledOnDayOrdinalNumber',
                    visible: false,
                    lookup: {
                        dataSource: getScheduledOrdinalDayOptions(),
                        displayExpr: 'name',
                        valueExpr: 'id',
                    },
                    setCellValue: function (newData, value, currentRowData) {
                        this.defaultSetCellValue(newData, value, currentRowData);

                        let onDay = newData.scheduledOnDayVal ?? currentRowData.scheduledOnDayVal;
                        if (value !== ScheduledOrdinalDayEnum.Last && value !== ScheduledOrdinalDayEnum.SpecificDays && onDay === ScheduledOnDayEnum.Day) {
                            newData.scheduledOnDayVal = ScheduledOnDayEnum.Sunday;
                        }

                        if (value !== ScheduledOrdinalDayEnum.Last && value !== ScheduledOrdinalDayEnum.First && onDay === ScheduledOnDayEnum.Weekday) {
                            newData.scheduledOnDayVal = ScheduledOnDayEnum.Sunday;
                        }
                    }
                },
                {
                    dataField: 'scheduledOnDayVal',
                    visible: false,
                    lookup: {
                        dataSource: getScheduledOnDayOptions(),
                        displayExpr: 'name',
                        valueExpr: 'id',
                    },
                },
                {
                    dataField: 'useAddressList',
                    visible: false,
                    editorType: 'dxSwitch' as any,
                    setCellValue: function (newData, value, currentRowData) {
                        this.defaultSetCellValue(newData, value, currentRowData);
                    }
                },
                {
                    dataField: 'filterId',
                    caption: 'Filter',
                    visible: false,
                    lookup: {
                        dataSource: [],
                        displayExpr: 'name',
                        valueExpr: 'id',
                    },
                    validationRules: [{
                        type: "custom",
                        validationCallback: function (v) {
                            //if you are not editing with the popup open, it does not validate
                            if (!isEditingInPopupMode(self)) {
                                return true;
                            }

                            if (!v.data.useAddressList) {
                                return true;
                            }

                            if (v.value === undefined || v.value === null || v.value === 0) {
                                return false;
                            }

                            return true;
                        },
                        message: "Filter is required"
                    }],
                    setCellValue: function (newData, value, currentRowData) {
                        this.defaultSetCellValue(newData, value, currentRowData);
                    }
                },
                {
                    dataField: 'companyName',
                    caption: 'Company',
                },
                {
                    dataField: 'companyId',
                    caption: 'Company',
                    visible: false,
                    lookup: {
                        dataSource: [],
                        displayExpr: 'name',
                        valueExpr: 'id',
                    },
                    validationRules: [{
                        type: "custom",
                        validationCallback: function (v) {
                            //if you are not editing with the popup open, it does not validate
                            if (!isEditingInPopupMode(self)) {
                                return true;
                            }

                            if (!irSettings.multiTenant) {
                                return true;
                            }

                            if (v.value === undefined || v.value === null || v.value === 0) {
                                return false;
                            }

                            return true;
                        },
                        message: "Company is required"
                    }],
                    setCellValue: function (newData, value, currentRowData: ScheduledEmail) {
                        if (irSettings.multiTenant) {
                            let company = params.result.companies.find(x => x.id === value);
                            newData.companyName = company?.name;

                            let pdfTemplateId = currentRowData.pdfTemplateId;
                            let pdfTemplate = params.result.pdfTemplates.find(x => x.id === pdfTemplateId);
                            if (pdfTemplate) {
                                if (!pdfTemplate.validCompany(company.id) || !pdfTemplate.validMapping(currentRowData.mappingId)) {
                                    newData.pdfTemplateId = 0;
                                }
                            }

                            if (currentRowData.useAddressList) {
                                let addressListId = currentRowData.addressListId;
                                let addressList = params.result.addressLists.find(x => x.id === addressListId);
                                if (addressList) {
                                    if (!addressList.validCompany(company.id) || !addressList.validMapping(currentRowData.mappingId)) {
                                        newData.addressListId = null;
                                        newData.filterId = null;
                                    }
                                }
                            }
                        }

                        this.defaultSetCellValue(newData, value, currentRowData);
                    }
                },
                {
                    dataField: 'sendReport',
                    caption: 'Enabled',
                    dataType: 'boolean',
                    visible: true,
                    editorType: 'dxSwitch',
                    headerFilter: {
                        dataSource: [
                            { value: ["sendReport", "=", false], text: "Off" },
                            { value: ["sendReport", "=", true], text: "On" }
                        ]
                    }
                },
                {
                    dataField: 'attachments',
                    visible: false
                },
                {
                    type: "buttons",
                    buttons: [{ name: "delete" }, {
                        hint: "Edit",
                        icon: "edit",
                        onClick(e) {
                            enablePopupMode(params.result, e);
                        }
                    }, {
                        hint: "Logs",
                        icon: "file",
                        onClick(e) {
                            Ir.Components.Email.EmailLog.show(e.row.key);
                        },
                        visible: params.result.emailsManagement && params.result.showEmailLogButton ? true : false
                    }, {
                        hint: "Show next execution dates",
                        icon: "clock",
                        onClick: function (e) {
                            showNextExecutionDates(e.row.data);
                        },
                    }, {
                        hint: "Send Now",
                        //icon: "video",
                        icon: "chevrondoubleright",
                        onClick(e) {
                            popupSendNow([e.row.key], self, params.result);
                        },
                        disabled(e) {
                            let scheduledEmail = e.row.data as ScheduledEmail;
                            let user = params.result.usersGroups?.find(x => x.id === scheduledEmail.userId);
                            if (user && !user.active) {
                                return true;
                            }

                            return false;
                        },
                    }]
                },
                {
                    dataField: 'starts',
                    caption: 'Starts',
                    visible: false,
                    dataType: "date",
                    setCellValue: function (newData, value, currentRowData) {
                        let newValue = value;
                        if (value && value instanceof Date) {
                            newValue = DevExpress.localization.formatDate(value, "yyyy-MM-dd");
                        }

                        this.defaultSetCellValue(newData, newValue, currentRowData);
                    }
                },

            ],
            showBorders: true,
            editing: {
                mode: "cell",//"popup",
                allowUpdating: true,
                allowDeleting: true,
                allowAdding: params.result.emailsManagement ? false : true,
                useIcons: true,
                form: {
                    alignItemLabelsInAllGroups: false,
                    onInitialized: function (e) {
                        self.dataGridFormEditComponent = e.component;
                    },
                    onContentReady: function (e) {
                        self.dataGridFormEditComponent.itemOption('attachments-container.attachmentList', 'items', getAttachmentsOptions(self, params.result));

                        let addButton = $(".scheduledEmail-attachment-add", e.element).css("display", "inline-block").css("margin-left", "10px");
                        let groupAttachment = $(".scheduledEmail-attachment-group .dx-form-group-caption", e.element);
                        addButton.insertAfter(groupAttachment);

                        /*
                            force fields to be validated even without having changed them, 
                            because when loading the emails we fix them, so when editing they need to be validated
                        */
                        setTimeout(function () {
                            var editData = e.element.find(".dx-validator").first().dxValidator("option", "validationGroup");
                            if (editData) {
                                editData.type = editData.type || "update";
                                DevExpress.validationEngine.validateGroup(editData);
                            }
                        }, 0);
                    },
                    customizeItem: function (item) {
                        if (item.dataField == "addressListId") {
                            let isVisible = getColumnValue("useAddressList", this.component);
                            item.visible = isVisible;
                        }

                        if (item.dataField == "filterId") {
                            let isVisible = getColumnValue("useAddressList", this.component);
                            item.visible = isVisible;
                        }

                        if (item.dataField === "companyId") {
                            let isVisible = irSettings.multiTenant;
                            item.visible = isVisible;
                        }

                        if (item.dataField === "sendEmptyReport") {
                            const scope = getColumnValue("scope", this.component);
                            let isDisabled = scope !== ContainerScopeEnum.Report && scope !== ContainerScopeEnum.Dashboard;
                            item.disabled = isDisabled;
                        }

                        if (item.dataField === "notificationText") {
                            const scope = getColumnValue("scope", this.component);
                            let isVisible = (scope === ContainerScopeEnum.Report || scope === ContainerScopeEnum.Dashboard) && getColumnValue("sendEmptyReport", this.component) === SendEmptyReportEnum.Notification;
                            item.visible = isVisible;
                        }

                        if (item.dataField === "widgetIdEmptyReport") {
                            const scope = getColumnValue("scope", this.component);
                            let isVisible = scope === ContainerScopeEnum.Dashboard && getColumnValue("sendEmptyReport", this.component) !== SendEmptyReportEnum.Yes;
                            item.visible = isVisible;
                        }

                        if (item.dataField == "recipients") {
                            let isVisible = !getColumnValue("useAddressList", this.component);
                            item.visible = isVisible;
                        }

                        if (item.dataField === "pdfTemplateId") {
                            const format = getColumnValue("formats", this.component);
                            const suppressReportHeader = getColumnValue("suppressReportHeader", this.component) as boolean;
                            item.disabled = suppressReportHeader || (format !== EmailFormatEnum.PDFLandscape && format !== EmailFormatEnum.PDF);
                        }

                        if (item.dataField === "suppressReportHeader") {
                            const pdfTemplateId = getColumnValue("pdfTemplateId", this.component);
                            item.disabled = pdfTemplateId > 0;
                        }

                        if (item.dataField == "scheduledHour") {
                            let isVisible = getColumnValue("multipleHours", this.component);
                            item.visible = !isVisible;
                        }

                        if (item.dataField == "scheduledHours") {
                            let isVisible = getColumnValue("multipleHours", this.component);
                            item.visible = isVisible;
                        }

                        if (item.dataField == "scheduledEveryMonths" || item.dataField == "scheduledOnDayOrdinalNumber" ||
                            item.dataField === "scheduledOnDayVal" || item.dataField == "scheduledDays") {
                            let isMonthly = getColumnValue("schedule", this.component) === ScheduledTypeEnum.Monthly;
                            let isWeekly = getColumnValue("schedule", this.component) === ScheduledTypeEnum.Weekly;
                            item.visible = isMonthly;

                            let specificDays = getColumnValue("scheduledOnDayOrdinalNumber", this.component) === ScheduledOrdinalDayEnum.SpecificDays;
                            if (item.dataField === "scheduledOnDayVal") {
                                item.visible = isMonthly && !specificDays;
                            }
                            else if (item.dataField == "scheduledDays") {
                                item.visible = (isMonthly && specificDays) || isWeekly;
                            }
                        }
                    },
                    items: [
                        {
                            itemType: 'group',
                            colCount: 7,
                            colSpan: 2,
                            items: [
                                {
                                    label: {
                                        template: (data) => $(`<div style="width: 74px">Enabled</div>`),
                                    },
                                    dataField: 'sendReport',
                                    colSpan: 1,
                                    //cssClass: "scheduleEmail-switch-margin"
                                },
                                {
                                    label: { visible: false },
                                    colSpan: 6,
                                    editorType: 'dxButton',
                                    editorOptions: {
                                        hint: "Show next execution dates",
                                        icon: "clock",
                                        onClick(e) {
                                            let validate = self.dataGridFormEditComponent.validate();
                                            if (validate.status === "valid") {
                                                let scheduleEmail = new ScheduledEmail(null);
                                                copyProperties(self.currentEmail(), scheduleEmail);
                                                if ((self.dataGridComponent.option("editing.changes") as any).length > 0) {
                                                    copyProperties(self.dataGridComponent.option("editing.changes")[0].data, scheduleEmail);
                                                }

                                                validateSchedule(scheduleEmail);
                                                showNextExecutionDates(scheduleEmail);
                                            }
                                        },
                                    },
                                }
                            ]
                        },
                        {
                            itemType: 'group',
                            colCount: 16,
                            colSpan: 2,
                            name: 'ScheduleDetails',
                            items: [
                                {
                                    label: {
                                        template: (data) => $(`<div style="width: 74px">Starts</div>`),
                                    },
                                    dataField: 'starts',
                                    colSpan: 4,
                                    cssClass: "scheduleEmail-switch-margin",
                                    editorType: 'dxDateBox',
                                    editorOptions: {
                                        displayFormat: irSettings.shortDateFormat,
                                        openOnFieldClick: true,
                                        showClearButton: true,
                                        width: 120
                                    }
                                },
                                {
                                    dataField: 'schedule',
                                    editorType: 'dxSelectBox',
                                    colSpan: 3,
                                    editorOptions: {
                                        items: [ScheduledTypeEnum.Daily, ScheduledTypeEnum.Weekly, ScheduledTypeEnum.Monthly],
                                    },
                                },
                                {
                                    dataField: 'multipleHours',
                                    editorType: 'dxSwitch',
                                    colSpan: 3,
                                    cssClass: "scheduleEmail-switch-margin"
                                },
                                {
                                    dataField: 'scheduledHour',
                                    editorType: 'dxDateBox',
                                    colSpan: 6,
                                    editorOptions: {
                                        type: 'time',
                                        useMaskBehavior: true,
                                        showDropDownButton: false,
                                        displayFormat: irSettings.displayTimeFormat,
                                    },
                                },
                                {
                                    dataField: 'scheduledHours',
                                    editorType: 'dxTagBox',
                                    colSpan: 6,
                                    editorOptions: {
                                        searchEnabled: true,
                                        showSelectionControls: true,
                                        dataSource: generateTimeSlots(),
                                        displayExpr: 'text',
                                        valueExpr: 'id',
                                        onClosed(e) {
                                            if (refreshByCode || !self.dataGridComponent.hasEditData()) { return };

                                            let arr = e.component.option('value');
                                            refreshByCode = true;

                                            if (arr.length > 0) {
                                                let sorted = arr.sort((a, b) => {
                                                    // Convert the time strings into numbers for comparison
                                                    let timeA = a.split(":").map(Number);
                                                    let timeB = b.split(":").map(Number);

                                                    // Convert hours and minutes into total minutes since midnight
                                                    return timeA[0] * 60 + timeA[1] - (timeB[0] * 60 + timeB[1]);
                                                });

                                                let email = self.currentEmail();
                                                let rowIndex = self.dataGridComponent.getRowIndexByKey(email.id);

                                                e.component.option('values', []);
                                                e.component.option('values', sorted);

                                                self.dataGridComponent.cellValue(rowIndex, "scheduledHours", sorted);

                                                e.component.repaint();
                                            }

                                            refreshByCode = false;
                                        }
                                    },
                                },
                                {
                                    itemType: 'group',
                                    colCount: 4,
                                    colSpan: 16,
                                    name: 'ScheduleDetailsHour',
                                    items: [
                                        {
                                            label: {
                                                template: (data) => $(`<div style="width: 74px">Every</div>`),
                                            },
                                            dataField: 'scheduledEveryMonths',
                                            colSpan: 1,
                                            editorOptions: {
                                                hint: "Starting in January",
                                                fieldTemplate(item) {
                                                    return $('<div />').dxTextBox({
                                                        value: `${item} month${(item > 1 ? "s" : "")}`
                                                    });
                                                }
                                            }
                                        },
                                        {
                                            label: { text: 'On' },
                                            dataField: 'scheduledOnDayOrdinalNumber',
                                            colSpan: 1
                                        },
                                        {
                                            label: { visible: false },
                                            dataField: 'scheduledOnDayVal',
                                            colSpan: 2,
                                            editorOptions: {
                                                itemTemplate(item, index, element) {
                                                    if (item.id === ScheduledOnDayEnum.Saturday) {
                                                        element.css("border-bottom", "1px solid #ccc");
                                                    }

                                                    return item.name;
                                                }
                                            }
                                        },
                                        {
                                            label: { text: 'Days' },
                                            dataField: 'scheduledDays',
                                            editorType: 'dxTagBox',
                                            colSpan: 2,
                                            editorOptions: {
                                                searchEnabled: true,
                                                showSelectionControls: true,
                                                dataSource: getScheduledDaysOptions(),
                                                displayExpr: 'name',
                                                valueExpr: 'id',
                                                onClosed: function (e) {
                                                    if (refreshByCode || !self.dataGridComponent.hasEditData()) { return };

                                                    let arr = e.component.option('value');

                                                    refreshByCode = true;

                                                    if (arr.length > 0) {
                                                        let sorted = arr.sort((n1, n2) => n1 - n2);
                                                        let email = self.currentEmail();
                                                        let rowIndex = self.dataGridComponent.getRowIndexByKey(email.id);

                                                        e.component.option('values', []);
                                                        e.component.option('values', sorted);

                                                        self.dataGridComponent.cellValue(rowIndex, "scheduledDays", sorted);

                                                        e.component.repaint();
                                                    }

                                                    refreshByCode = false;
                                                }
                                            }
                                        },
                                    ]
                                }
                            ],
                        },
                        {
                            itemType: 'group',
                            colCount: 2,
                            colSpan: 2,
                            items: [{
                                dataField: 'userId',
                                colSpan: 1,
                                label: {
                                    template: (data) => $(`<div style="width: 66px">${data.text}</div>`),
                                },
                            }, {
                                dataField: 'useAddressList',
                                cssClass: "scheduleEmail-switch-margin",
                                visible: !irSettings.multiTenant
                            }]
                        },
                        {
                            itemType: 'group',
                            colCount: 2,
                            colSpan: 2,
                            visible: irSettings.multiTenant,
                            items: [
                                {
                                    dataField: 'companyId',
                                    colSpan: 1,
                                    label: {
                                        template: (data) => $(`<div style="width: 74px">${data.text}</div>`),
                                    },
                                },
                                {
                                    dataField: 'useAddressList',
                                    cssClass: "scheduleEmail-switch-margin"
                                }
                            ],
                        },
                        {
                            itemType: 'group',
                            colCount: 2,
                            colSpan: 2,
                            items: [
                                {
                                    caption: 'Address List',
                                    dataField: 'addressListId',
                                    colSpan: 1,
                                    label: {
                                        template: (data) => $(`<div style="width: 74px">${data.text}</div>`),
                                    },
                                },
                                {
                                    dataField: 'filterId',
                                    colSpan: 1,
                                    label: {
                                        template: (data) => $(`<div style="width: 104px">${data.text}</div>`),
                                    },
                                }
                            ],
                        },
                        {
                            itemType: 'group',
                            colCount: 2,
                            colSpan: 2,
                            items: [
                                {
                                    dataField: 'recipients',
                                    colSpan: 2,
                                },
                                {
                                    caption: 'CC',
                                    dataField: 'cc',
                                },
                                {
                                    caption: 'BCC',
                                    dataField: 'bcc',
                                },
                                'tabId', { dataField: 'scope', disabled: true, visible: false },
                                { caption: 'Send Empty Report', dataField: 'sendEmptyReport' }, 
                                'pdfTemplateId', 'suppressReportHeader',
                                {
                                    dataField: 'widgetIdEmptyReport', editorOptions: { placeholder: "Verification Widget" }
                                }, 
                                { dataField: 'notificationText', caption: 'Notification Text' },
                            ],
                        },
                        {
                            itemType: 'group',
                            colCount: 2,
                            colSpan: 2,
                            caption: 'Email',
                            items: [{
                                dataField: 'subjectText',
                                label: {
                                    template: (data, element) => {
                                        const dataGrid = self.dataGridComponent;
                                        const useAddressList = dataGrid.cellValue(dataGrid.getRowIndexByKey(self.currentEmail().id), "useAddressList");
                                        const hasFilter = dataGrid.cellValue(dataGrid.getRowIndexByKey(self.currentEmail().id), "filterId") > 0;
                                        const infoIcon = useAddressList && hasFilter ? ' <i id="helpedInfo" class="dx-icon dx-icon-info" style="color: #63a0d4"></i>' : "";
                                        const labelText = `Subject`;

                                        element.append(`<div id='template-content'>${labelText}${infoIcon}</div>`);

                                        $('<div>').dxTooltip({
                                            target: '#helpedInfo',
                                            showEvent: 'mouseenter',
                                            hideEvent: 'mouseleave',
                                            contentTemplate(args) {
                                                args.html('<div id="tooltip-content" style="font-size: 12px">Use the [AddressListFilter] tag to add the filter value in the email subject and body text</div>');
                                            },
                                        }).appendTo(element);

                                        $('#helpedInfo', element).click(function () {
                                            let subjectText = dataGrid.cellValue(dataGrid.getRowIndexByKey(self.currentEmail().id), "subjectText");
                                            if (subjectText) {
                                                subjectText += " [AddressListFilter]";
                                            }
                                            dataGrid.cellValue(dataGrid.getRowIndexByKey(self.currentEmail().id), "subjectText", subjectText);
                                        });
                                    },
                                }
                            }, 'formats',
                            {
                                dataField: 'bodyText',
                                editorType: 'dxTextArea',
                                colSpan: 2,
                                editorOptions: {
                                    height: 100,
                                }
                            }
                            ],
                        },
                        {
                            itemType: 'group',
                            caption: 'Attachments',
                            cssClass: "scheduledEmail-attachment-group",
                            name: 'attachments-container',
                            colCount: 2,
                            colSpan: 2,
                            items: [
                                {
                                    colSpan: 2,
                                    cssClass: "scheduledEmail-attachment-add",
                                    editorType: 'dxButton',
                                    editorOptions: {
                                        icon: 'add',
                                        text: 'Add',
                                        onClick() {
                                            if (self.currentEmail().attachments === undefined) {
                                                self.currentEmail().attachments = [];
                                            }
                                            self.currentEmail().attachments.push(new AttachmentTab());
                                            self.dataGridFormEditComponent.itemOption('attachments-container.attachmentList', 'items', getAttachmentsOptions(self, params.result));
                                            self.dataGridComponent.cellValue(self.dataGridComponent.getRowIndexByKey(self.currentEmail().id), "attachments", self.currentEmail().attachments);
                                        },
                                    },
                                },
                                {
                                    itemType: 'group',
                                    name: 'attachmentList',
                                    colSpan: 2,
                                    colCount: 2,
                                    items: getAttachmentsOptions(self, params.result),
                                },
                                {
                                    itemType: 'group',
                                    colSpan: 2,
                                    colCount: 2,
                                    cssClass: "scheduledEmail-attachment-space",
                                    items: [],
                                }
                            ]
                        }
                    ],
                },
                popup: {
                    title: params.result.emailsManagement ? 'Emails Management' : 'Scheduled Emails',
                    showTitle: true,
                    width: 1000,
                    height: "90%",
                    toolbarItems: [{
                        location: "before",
                        toolbar: "bottom",
                        template() {
                            return $('<label>').text(`Server Date: ${params.result.serverDate}`);
                        },
                    }, {
                        toolbar: "bottom",
                        widget: "dxButton",
                        location: "after",
                        options: {
                            icon: 'save',
                            stylingMode: 'contained',
                            type: 'default',
                            text: "Save",
                            onClick: function () {
                                self.dataGridComponent.saveEditData();
                            }
                        }
                    }, {
                        toolbar: "bottom",
                        widget: "dxButton",
                        location: "after",
                        options: {
                            text: 'Cancel',
                            icon: 'remove',
                            stylingMode: 'outlined',
                            type: 'normal',
                            onClick: function () {
                                self.dataGridComponent.cancelEditData();
                            }
                        }
                    }]
                },
            },
            focusedRowEnabled: true,
            keyExpr: "id",
            focusedRowIndex: 0,
            toolbar: !params.result.emailsManagement ? undefined : {
                items: [
                    "searchPanel",
                    {
                        location: 'after',
                        widget: 'dxButton',
                        options: {
                            hint: "Filters",
                            icon: 'filter',
                            name: 'filter',
                            onClick: function (e) {
                                Ir.Components.Email.ScheduledEmailFilter.show(params.result, (filterValue) => {
                                    if (self.dataGridComponent.option("filterValue") !== filterValue) {
                                        self.dataGridComponent.option("filterValue", filterValue);
                                    }

                                    $(".dx-toolbar .dx-button[aria-label='filter'] i.dx-icon-filter", "#scheduledEmailsGrid").css("color", filterValue ? "#337ab7" : "#333");
                                });
                            }
                        }
                    },
                    {
                        location: 'after',
                        widget: 'dxButton',
                        options: {
                            hint: "Send Selected Emails",
                            icon: 'chevrondoubleright',
                            text: "Send",
                            onClick: function (e) {
                                const keys = self.dataGridComponent.getSelectedRowKeys();
                                popupSendNow(keys, self, params.result);
                            },
                            disabled: true
                        }
                    }
                ],
            },
            onInitialized: function (e) {
                self.dataGridComponent = e.component;

                e.component.emailsManagement = params.result.emailsManagement;
                e.component.tabs = params.result.tabs || [];
                e.component.usersGroups = params.result.usersGroups || [];
                e.component.widgets = params.result.widgets || [];
            },
            onEditorPreparing: function (e) {
                if (e.parentType === "dataRow") {
                    let scheduledEmail = e.row.data as ScheduledEmail;

                    if (e.dataField === "scheduledDays") {
                        e.editorOptions.enable = e.row.data && scheduledEmail.schedule !== ScheduledTypeEnum.Daily;
                        let data = [];
                        if (scheduledEmail.schedule === ScheduledTypeEnum.Weekly)
                            data = getScheduledDaysOptions();
                        else if (scheduledEmail.schedule === ScheduledTypeEnum.Monthly) {
                            data = Array.from({ length: 31 }, (_, i) => ({
                                id: i + 1,
                                name: i + 1
                            }));
                        }
                        e.editorOptions.dataSource = data;
                    }
                    else if (e.dataField === "formats") {
                        switch (scheduledEmail.scope) {
                            case ContainerScopeEnum.Workbook:
                                formatList = [
                                    { id: EmailFormatEnum.PDFLandscape, name: "PDF Landscape" },
                                    { id: EmailFormatEnum.PDF, name: "PDF" }
                                ];
                                break;
                            case ContainerScopeEnum.Dashboard:
                                formatList = [
                                    { id: EmailFormatEnum.PDFLandscape, name: "PDF Landscape" },
                                    { id: EmailFormatEnum.PDF, name: "PDF" },
                                    { id: EmailFormatEnum.Image, name: "Image" }
                                ];
                                break;
                            case ContainerScopeEnum.Report:
                                formatList = getFormats(scheduledEmail, e.component.tabs);
                                break;
                        }
                        e.editorOptions.dataSource = formatList;
                        e.editorOptions.itemTemplate = function (data) {
                            let style = "";
                            if (!loggedUser.permissions.printExportPDF() && (data.id === EmailFormatEnum.PDFLandscape || data.id === EmailFormatEnum.PDF || data.id === EmailFormatEnum.Image || data.id === EmailFormatEnum.EmailBody) ||
                                !loggedUser.permissions.exportExcelCSV() && (data.id === EmailFormatEnum.Excel || data.id === EmailFormatEnum.CSV || data.id === EmailFormatEnum.ExcelWithoutHeaders || data.id === EmailFormatEnum.CSVWithoutHeaders)) {
                                style = "color: #afadad;";
                            }

                            return `<div style="${style}">${data.name}</div>`;
                        }
                    }
                    else if (e.dataField === "filterId") {
                        let mapping = MappingService.getMapping(scheduledEmail.mappingId);
                        let addressList = params.result.addressLists.find(x => x.id === scheduledEmail.addressListId);
                        let hasMapping = addressList ? addressList.hasMapping(mapping.id) : false;

                        e.editorOptions.disabled = hasMapping ?? !addressList;
                        e.editorOptions.dataSource = addressList ? getFilters(mapping, !hasMapping, scheduledEmail.filterId) : [];
                        e.editorOptions.itemTemplate = function (data: FilterTemplate) {
                            let style = "";
                            if (data.visibility === VisibilityEnum.Deprecated) {
                                style = "color: #afadad;";
                            }

                            return `<div style="${style}">${data.name}</div>`;
                        }
                    }
                    else if (e.dataField === "tabId") {
                        e.editorOptions.dataSource = e.component.tabs.filter(function (x) { return x.id >= 0; });
                    }
                    else if (e.dataField === "userId") {
                        e.editorOptions.dataSource = e.component.usersGroups.filter(function (x: ScheduledEmailUserGroupVM) {
                            return x.active || (!x.active && x.id === scheduledEmail?.userId);
                        });
                    }
                    else if (e.dataField === "companyId") {
                        e.editorOptions.dataSource = params.result.companies.filter(function (x) { return x.users.includes(scheduledEmail.userId); });
                    }
                    else if (e.dataField === "addressListId") {
                        if (irSettings.multiTenant) {
                            let company = CompanyService.getCompany(scheduledEmail.companyId);
                            e.editorOptions.dataSource = company ? params.result.addressLists.filter(function (x) {
                                return x.validCompany(company.id) && x.validMapping(scheduledEmail.mappingId);
                            }) : [];
                        }
                        else {
                            e.editorOptions.dataSource = params.result.addressLists.filter(function (x) {
                                return x.validMapping(scheduledEmail.mappingId);
                            });
                        }
                    }
                    else if (e.dataField === "widgetIdEmptyReport") {
                        e.editorOptions.dataSource = e.component.widgets.filter(function (x) { return x.id === 0 || (x.id >= 0 && x.tabId == scheduledEmail.tabId); });
                    }
                    else if (e.dataField === "scheduledOnDayVal") {
                        e.editorOptions.dataSource = getScheduledOnDayOptions(scheduledEmail.scheduledOnDayOrdinalNumber);
                    }
                }
            },
            onRowInserted: function (e) {
                e.component.option("focusedRowKey", e.data.id);
            },
            onEditingStart: function (e) {
                if (e.column) {
                    e.cancel = e.column.dataField !== "sendReport";
                }
            },
            onEditCanceling: function (e) {
                newRow = false;
            },            
            onFocusedRowChanged: function (e) {
                if (!newRow) {
                    self.currentEmail(e.row?.data);
                }

                if (self.currentEmail()) {
                    self.formDetailsComponent.itemOption('ScheduleDetails.scheduledDaysWeekly', 'visible', self.currentEmail().schedule === ScheduledTypeEnum.Weekly);
                    self.formDetailsComponent.itemOption('ScheduleDetails.scheduledDaysMonthly', 'visible', self.currentEmail().schedule === ScheduledTypeEnum.Monthly);
                }
            },
            onSaving: function (e) {
                newRow = false;

                if (isEditingInPopupMode(self)) {
                    if (!loggedUser.permissions.printExportPDF() && !loggedUser.permissions.exportExcelCSV()) {
                        DevExpress.ui.dialog.alert("User does not have 'Print Report and Export PDF' or 'Export to Excel/CSV' permission.", "Scheduled Emails");
                        e.cancel = true;
                    }
                    else {
                        let email = self.currentEmail() as ScheduledEmail;
                        if (e.changes.length > 0) {
                            //clone
                            email = JSON.parse(JSON.stringify(email));
                            copyProperties(e.changes[0].data, email);
                        }

                        let cancel = false;
                        if (!loggedUser.permissions.printExportPDF() || !loggedUser.permissions.exportExcelCSV()) {
                            if (!loggedUser.permissions.printExportPDF() && (email.formats === EmailFormatEnum.PDF || email.formats === EmailFormatEnum.PDFLandscape || email.formats === EmailFormatEnum.Image || email.formats === EmailFormatEnum.EmailBody) ||
                                !loggedUser.permissions.exportExcelCSV() && (email.formats === EmailFormatEnum.Excel || email.formats === EmailFormatEnum.CSV || email.formats === EmailFormatEnum.ExcelWithoutHeaders || email.formats === EmailFormatEnum.CSVWithoutHeaders)) {
                                cancel = true;
                            }

                            if (email.attachments) {
                                email.attachments.forEach(function (attachment) {
                                    if (!loggedUser.permissions.printExportPDF() && (attachment.format === EmailFormatEnum.PDF || attachment.format === EmailFormatEnum.PDFLandscape) ||
                                        !loggedUser.permissions.exportExcelCSV() && (attachment.format === EmailFormatEnum.Excel || attachment.format === EmailFormatEnum.ExcelWithoutHeaders || attachment.format === EmailFormatEnum.CSV || attachment.format === EmailFormatEnum.CSVWithoutHeaders)) {
                                        cancel = true;
                                    }
                                });
                            }
                        }

                        if (cancel) {
                            DevExpress.ui.dialog.alert(`User does not have ${(!loggedUser.permissions.printExportPDF() ? "Print Report and Export PDF" : "Export to Excel/CSV")} permission.`, "Scheduled Emails");
                            e.cancel = true;
                        }

                        if (email.sendEmptyReport !== SendEmptyReportEnum.Yes && email.scope === ContainerScopeEnum.Dashboard) {
                            if ((email.widgetIdEmptyReport === 0 && email.widgetIdEmptyReport === null) || !e.component.widgets.find(function (x) { return x.id == email.widgetIdEmptyReport && x.tabId == email.tabId; })) {
                                DevExpress.ui.dialog.alert("Widget is required.", "Email");
                                e.cancel = true;
                            }
                        }

                        if (email.formats === EmailFormatEnum.Image || email.formats === EmailFormatEnum.EmailBody) {
                            let tab: ScheduledEmailTabVM = e.component.tabs.find(t => t.id === email.tabId);
                            if (!irSettings.emailBodyHTML || !tab) {
                                e.cancel = true;
                            }

                            if (email.formats === EmailFormatEnum.EmailBody && tab.reportType !== "Analysis") {
                                e.cancel = true;
                            }
                        }
                    }
                }
            },
            onSaved: function (e) {
                if (self.currentEmail()) {
                    self.formDetailsComponent.itemOption('ScheduleDetails.scheduledDaysWeekly', 'visible', self.currentEmail().schedule === ScheduledTypeEnum.Weekly);
                    self.formDetailsComponent.itemOption('ScheduleDetails.scheduledDaysMonthly', 'visible', self.currentEmail().schedule === ScheduledTypeEnum.Monthly);
                    self.formDetailsComponent.itemOption('ScheduleDetails.scheduledHours', 'value', self.currentEmail().scheduledHours);
                }
            },
            onInitNewRow: function (e) {
                newRow = true;
                let newScheduledEmail = new ScheduledEmail();
                newScheduledEmail.workbookId = params.result.workbookId;
                newScheduledEmail.mappingId = params.result.mappingId;
                newScheduledEmail.userId = loggedUser.id();
                newScheduledEmail.userName = loggedUser.userName();
                newScheduledEmail.subjectText = params.result.workbookName;

                let activeTab = workbook?.workbookConfig?.activeTab?.();
                if (activeTab && activeTab.id() > 0) {
                    newScheduledEmail.tabId = activeTab.id();
                    newScheduledEmail.scope = activeTab.tabType() === TabTypeEnum.Dashboard ? ContainerScopeEnum.Dashboard : ContainerScopeEnum.Report;
                    newScheduledEmail.tabName = activeTab?.name();
                }

                if (irSettings.multiTenant) {
                    newScheduledEmail.companyId = loggedUser.companyId();
                    newScheduledEmail.companyName = CompanyService.getCompanyName(loggedUser.companyId());
                }

                newScheduledEmail.organisationId = loggedUser.orgId();

                let userGroup = params.result.usersGroups.find(x => x.id === loggedUser.id());
                if (userGroup) {
                    newScheduledEmail.recipients = userGroup.email;
                }

                if (irSettings.multiTenant) {
                    let company = params.result.companies.find(x => x.id === newScheduledEmail.companyId);
                    if (company) {
                        newScheduledEmail.companyName = company.name;
                    }
                }

                e.data = newScheduledEmail;
                self.currentEmail(e.data);
                enablePopupMode(params.result, e, true);
            },
            onSelectionChanged: function (e) {
                if (params.result.emailsManagement) {
                    const isDisabled = e.component.option("toolbar.items[2].options.disabled");
                    if (isDisabled !== (e.selectedRowKeys.length === 0)) {
                        e.component.beginUpdate();
                        e.component.option("toolbar.items[2].options.disabled", e.selectedRowKeys.length === 0);
                        const columns = e.component.option("columns");
                        const buttonColumn = columns.find(x => x.type === "buttons");
                        for (var i = 0; i < buttonColumn.buttons.length; i++) {
                            e.component.option(`columns[${columns.indexOf(buttonColumn)}].buttons[${i}].disabled`, e.selectedRowKeys.length > 0)
                        }
                        e.component.endUpdate();
                        e.component.repaint();
                    }
                }
            },
            onRowPrepared(e) {
                if (e.data) {
                    let scheduledEmail = e.data as ScheduledEmail;
                    let user = params.result.usersGroups?.find(x => x.id === scheduledEmail.userId);
                    if (user && !user.active) {
                        e.rowElement.addClass("ir-inactive");
                    }
                }
            },
        } as any;
        this.formOptions = {
            height: 240,
            onInitialized: function (e) {
                self.formDetailsComponent = e.component;
            },
            readOnly: true,
            formData: self.currentEmail,
            elementAttr: {
                class: "scheduledEmailDetails"
            },
            items: [
                {
                    itemType: 'group',
                    colCount: 9,
                    caption: 'Schedule Details',
                    name: 'ScheduledDetails',
                    items: [
                        {
                            dataField: 'starts',
                            editorType: 'dxDateBox',
                            colSpan: 2,
                            editorOptions: {
                                type: 'date',
                                showDropDownButton: false,
                                displayFormat: irSettings.shortDateFormat,
                                width: 100
                            },
                        },
                        {
                            dataField: 'schedule',
                            editorType: 'dxSelectBox',
                            colSpan: 2,
                            editorOptions: {
                                items: [ScheduledTypeEnum.Daily, ScheduledTypeEnum.Weekly, ScheduledTypeEnum.Monthly],
                            },
                        },
                        {
                            dataField: 'scheduledHours',
                            editorType: 'dxTagBox',
                            colSpan: 3,
                            editorOptions: {
                                searchEnabled: true,
                                showSelectionControls: true,
                                dataSource: generateTimeSlots(),
                                displayExpr: 'text',
                                valueExpr: 'id',
                            },
                            visible: false
                        },
                        {
                            dataField: 'scheduledHour',
                            editorType: 'dxDateBox',
                            colSpan: 3,
                            editorOptions: {
                                type: 'time',
                                useMaskBehavior: true,
                                showDropDownButton: false,
                                displayFormat: irSettings.displayTimeFormat,
                            },
                            visible: true
                        },
                        {
                            dataField: 'scheduledEveryMonths',
                            visible: false,
                            colSpan: 1,
                            label: {
                                location: "right",
                                template(e) {
                                    return "month(s)";
                                }
                            }
                        },
                        {
                            label: { text: 'On' },
                            dataField: 'scheduledOnDayOrdinalNumber',
                            visible: false,
                            editorType: "dxDropDownBox",
                            colSpan: 1,
                            editorOptions: {
                                dataSource: getScheduledOrdinalDayOptions(),
                                displayExpr: 'name',
                                valueExpr: 'id'
                            }
                        },
                    ],
                },
                {
                    itemType: 'group',
                    name: 'SecondRowScheduledDetails',
                    items: [
                        {
                            label: { visible: false },
                            dataField: 'scheduledOnDayVal',
                            visible: false,
                            editorType: "dxDropDownBox",
                            colSpan: 1,
                            editorOptions: {
                                dataSource: getScheduledOnDayOptions(),
                                displayExpr: 'name',
                                valueExpr: 'id',
                            }
                        },
                        {
                            label: { text: 'Days' },
                            name: 'scheduledDaysWeekly',
                            dataField: 'scheduledDays',
                            editorType: 'dxTagBox',
                            colSpan: 2,
                            editorOptions: {
                                searchEnabled: true,
                                showSelectionControls: true,
                                dataSource: getScheduledDaysOptions(),
                                displayExpr: 'name',
                                valueExpr: 'id',
                            }
                        },
                        {
                            label: { text: 'Days' },
                            name: 'scheduledDaysMonthly',
                            dataField: 'scheduledDays',
                            editorType: 'dxTagBox',
                            cssClass: "scheduledEmail-form-item-hackInvisible",
                            colSpan: 2,
                            editorOptions: {
                                searchEnabled: true,
                                showSelectionControls: true,
                                items: Array.from({ length: 31 }, (_, i) => ({
                                    id: i + 1,
                                    name: i + 1
                                })),
                                displayExpr: 'name',
                                valueExpr: 'id',
                                onValueChanged: function (e) {
                                    let arr = e.component.option('value');

                                    if (arr.length > 0) {
                                        let sorted = arr.sort((n1, n2) => n1 - n2);

                                        e.component.option('values', sorted);

                                        try {
                                            e.component.repaint();
                                        } catch (e) { console.log('exception on repaint'); }
                                    }
                                }
                            }
                        },]
                },
                {
                    itemType: 'group',
                    colCount: 5,
                    colSpan: 5,
                    caption: 'Information',
                    items: [
                        {
                            dataField: 'dateAddedFormatted',
                            label: { text: 'Date Added' },
                            colSpan: 2
                        },
                        {
                            dataField: 'lastEmailSent',
                            caption: 'Last Email Sent',
                            editorType: 'dxCheckBox',
                            colSpan: 1,
                        },
                        {
                            dataField: 'lastSentDateFormatted',
                            label: { text: 'Last Sent Date' },
                            colSpan: 2
                        },
                        {
                            dataField: 'lastStatus',
                            caption: 'Last Status',
                            colSpan: 5,
                        },
                        {
                            dataField: 'lastSmtpResponse',
                            caption: 'Last STMP Response',
                            colSpan: 5,
                        },
                        {
                            dataField: 'emailCount',
                            caption: 'Email Count',
                            colSpan: 1,
                        },

                    ]
                }
            ],
            onFieldDataChanged(e) {
                if (e.dataField === "scheduledHour") {
                    self.formDetailsComponent.itemOption("ScheduledDetails.scheduledHour", "visible", !self.currentEmail().multipleHours);
                }

                if (e.dataField === "scheduledHours") {
                    self.formDetailsComponent.itemOption("ScheduledDetails.scheduledHours", "visible", self.currentEmail().multipleHours);
                }
                
                if (e.dataField === "scheduledEveryMonths") {
                    self.formDetailsComponent.itemOption("ScheduledDetails.scheduledEveryMonths", "visible", self.currentEmail().schedule === ScheduledTypeEnum.Monthly);
                }

                if (e.dataField === "scheduledDays") {
                    let monthly = self.currentEmail().schedule === ScheduledTypeEnum.Monthly && self.currentEmail().scheduledOnDayOrdinalNumber === ScheduledOrdinalDayEnum.SpecificDays;
                    if (monthly) {
                        e.element.removeClass("scheduledEmail-form-item-use-hackInvisible");
                    }
                    else {
                        e.element.addClass("scheduledEmail-form-item-use-hackInvisible");
                    }
                    self.formDetailsComponent.itemOption("SecondRowScheduledDetails.scheduledDaysMonthly", "visible", monthly);
                    self.formDetailsComponent.itemOption("SecondRowScheduledDetails.scheduledDaysWeekly", "visible", self.currentEmail().schedule === ScheduledTypeEnum.Weekly);
                }

                if (e.dataField === "scheduledOnDayOrdinalNumber") {
                    self.formDetailsComponent.itemOption("ScheduledDetails.scheduledOnDayOrdinalNumber", "visible", self.currentEmail().schedule === ScheduledTypeEnum.Monthly);
                }

                if (e.dataField === "scheduledOnDayVal") {
                    self.formDetailsComponent.itemOption("SecondRowScheduledDetails.scheduledOnDayVal", "visible", self.currentEmail().scheduledOnDayOrdinalNumber !== ScheduledOrdinalDayEnum.SpecificDays);
                }
            }
        };
    }

    function getScheduledOnDayOptions(ordinalDay: ScheduledOrdinalDayEnum = undefined) {
        let options = [
            { id: ScheduledOnDayEnum.Sunday, name: "Sunday" },
            { id: ScheduledOnDayEnum.Monday, name: "Monday" },
            { id: ScheduledOnDayEnum.Tuesday, name: "Tuesday" },
            { id: ScheduledOnDayEnum.Wednesday, name: "Wednesday" },
            { id: ScheduledOnDayEnum.Thursday, name: "Thursday" },
            { id: ScheduledOnDayEnum.Friday, name: "Friday" },
            { id: ScheduledOnDayEnum.Saturday, name: "Saturday" },
            { id: ScheduledOnDayEnum.Day, name: "Day" },
            { id: ScheduledOnDayEnum.Weekday, name: "Weekday" },
        ];

        if (ordinalDay !== undefined) {
            if (ordinalDay !== ScheduledOrdinalDayEnum.SpecificDays && ordinalDay !== ScheduledOrdinalDayEnum.Last) {
                options = options.filter(x => x.id !== ScheduledOnDayEnum.Day);
            }

            if (ordinalDay === ScheduledOrdinalDayEnum.Second || ordinalDay === ScheduledOrdinalDayEnum.Third || ordinalDay === ScheduledOrdinalDayEnum.Fourth) {
                options = options.filter(x => x.id !== ScheduledOnDayEnum.Weekday);
            }
        }

        return options;
    }

    function getScheduledOrdinalDayOptions() {
        return [
            { id: ScheduledOrdinalDayEnum.SpecificDays, name: "Specific Days" },
            { id: ScheduledOrdinalDayEnum.First, name: "First" },
            { id: ScheduledOrdinalDayEnum.Second, name: "Second" },
            { id: ScheduledOrdinalDayEnum.Third, name: "Third" },
            { id: ScheduledOrdinalDayEnum.Fourth, name: "Fourth" },
            { id: ScheduledOrdinalDayEnum.Last, name: "Last" },
        ];
    }

    function getScheduledDaysOptions() {
        return [
            { id: ScheduledDayOfWeekEnum.Sunday, name: "Sunday" },
            { id: ScheduledDayOfWeekEnum.Monday, name: "Monday" },
            { id: ScheduledDayOfWeekEnum.Tuesday, name: "Tuesday" },
            { id: ScheduledDayOfWeekEnum.Wednesday, name: "Wednesday" },
            { id: ScheduledDayOfWeekEnum.Thursday, name: "Thursday" },
            { id: ScheduledDayOfWeekEnum.Friday, name: "Friday" },
            { id: ScheduledDayOfWeekEnum.Saturday, name: "Saturday" },
        ];
    }

    function isEditingInPopupMode(self: IViewModel) {
        return self.dataGridComponent.option("editing.mode") === "popup";
    }

    function validateSchedule(scheduleEmail: ScheduledEmail) {
        if (scheduleEmail.useAddressList) {
            scheduleEmail.recipients = " ";
        }
        else {
            scheduleEmail.addressListId = null;
            scheduleEmail.filterId = null;
        }

        if (scheduleEmail.scope === ContainerScopeEnum.Workbook) {
            scheduleEmail.tabId = 0;
        }

        if (!irSettings.multiTenant) {
            scheduleEmail.companyId = null;
            scheduleEmail.companyName = "";
        }

        if (scheduleEmail.sendEmptyReport === SendEmptyReportEnum.Yes) {
            scheduleEmail.widgetIdEmptyReport = 0;
        }

        if (scheduleEmail.multipleHours && scheduleEmail.scheduledHours) {
            scheduleEmail.scheduledHours = scheduleEmail.scheduledHours.sort((a, b) => {
                // Convert the time strings into numbers for comparison
                let timeA = a.split(":").map(Number);
                let timeB = b.split(":").map(Number);

                // Convert hours and minutes into total minutes since midnight
                return timeA[0] * 60 + timeA[1] - (timeB[0] * 60 + timeB[1]);
            });
        }

        if (scheduleEmail.scheduledDays) {
            scheduleEmail.scheduledDays = scheduleEmail.scheduledDays.sort((n1, n2) => n1 - n2);
        }

        if (scheduleEmail.schedule === ScheduledTypeEnum.Monthly) {
            if (scheduleEmail.scheduledOnDayOrdinalNumber === ScheduledOrdinalDayEnum.SpecificDays) {
                scheduleEmail.scheduledOnDay = "";
            }
            else {

                scheduleEmail.scheduledOnDay = `${scheduleEmail.scheduledOnDayVal}#${scheduleEmail.scheduledOnDayOrdinalNumber}`;
                scheduleEmail.scheduledDays = [];
            }
        }
        else {
            scheduleEmail.scheduledOnDayOrdinalNumber = ScheduledOrdinalDayEnum.SpecificDays;
            scheduleEmail.scheduledOnDayVal = ScheduledOnDayEnum.Sunday;
            scheduleEmail.scheduledOnDay = "";
        }
    };

    function copyProperties(fromObject, toObject) {
        for (let property in fromObject) {
            if (fromObject[property] !== undefined) {
                let fromValue = fromObject[property];
                if (Array.isArray(fromValue)) {
                    toObject[property] = fromValue;
                }
                else if (typeof fromValue === "object" && fromValue !== null) {
                    copyProperties(fromValue, toObject[property] || {});
                }
                else {
                    toObject[property] = fromValue;
                }
            }
        }
    }

    function copyIds(data, email) {
        email.id = data.id;
        email.attachments = data.attachments;
        email.scheduleId = data.scheduleId;
    };

    function getFormatList(tabType) {
        let formatList = [
            { id: EmailFormatEnum.PDFLandscape, name: "PDF Landscape" },
            { id: EmailFormatEnum.PDF, name: "PDF" },
            { id: EmailFormatEnum.Excel, name: "XLSX" },
            { id: EmailFormatEnum.ExcelWithoutHeaders, name: "Simple XLSX" },
            { id: EmailFormatEnum.CSV, name: "CSV" },
            { id: EmailFormatEnum.CSVWithoutHeaders, name: "Simple CSV" }
        ];
        if (tabType && tabType === "Dashboard") {
            formatList = [
                { id: EmailFormatEnum.PDFLandscape, name: "PDF Landscape" },
                { id: EmailFormatEnum.PDF, name: "PDF" }
            ];
        }

        return formatList;
    }

    function generateTimeSlots() {
        const timeSlots = [];

        for (let hour = 0; hour < 24; hour++) {
            for (let minute = 0; minute < 60; minute += 30) {
                const formattedHour = String(hour).padStart(2, '0');
                const formattedMinute = String(minute).padStart(2, '0');
                let displayFormattedHour = formattedHour;

                let displayHour = `${displayFormattedHour}:${formattedMinute}`;
                if (irSettings.usesAmPm) {
                    displayHour = convertTo12HourFormat(displayHour);
                }

                timeSlots.push({ id: `${formattedHour}:${formattedMinute}:00`, text: `${displayHour}` });
            }
        }
        return timeSlots;
    }

    function showToast(message = undefined, type = undefined, width = 300) {
        if (!message || message === "") {
            return;
        }

        if (type === undefined) {
            type = "success";
        }

        DevExpress.ui.notify({
            message: message,
            type: type,
            position: { my: 'right top', at: 'right top', offset: { x: -20, y: 20 } },
            width: width
        });
    };

    function popupSendNow(emailsId: Array<number>, self: IViewModel, result: ScheduledEmailResultVM) {
        let messageResult = DevExpress.ui.dialog.confirm(`Do you confirm sending the email${(emailsId.length > 1 ? "s" : "")} now?`, "Confirm");

        let updateEmails = function (emailsVM) {
            for (let emailVM of emailsVM) {
                let email = result.emails.find(x => x.id === emailVM.id);
                if (email) {
                    email.lastEmailSent = emailVM.lastEmailSent;
                    email.lastMessageId = emailVM.lastMessageId;
                    email.lastSentDate = emailVM.lastSentDate;
                    email.lastSmtpResponse = emailVM.lastSmtpResponse;
                    email.lastStatus = emailVM.lastStatus;
                    email.emailCount = emailVM.emailCount;

                    if (self.currentEmail() && self.currentEmail().id === email.id) {
                        self.currentEmail(email);
                    }
                }
            }
        }
        let success = function (resp) {
            updateEmails(resp.emails);

            if (resp.success) {
                let allEmailsSent = resp.emails.length === 0 ? true : resp.emails.filter(x => x.lastEmailSent).length === resp.emails.length;
                if (allEmailsSent) {
                    showToast('Success');
                }
                else {
                    showToast('Some emails were not sent', 'warning');
                }
            }
            else {
                error(resp.message, "", {} as any);
            }
        }

        let error = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to send email";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        messageResult.done(function (dialogResult) {
            if (dialogResult) {
                irGlobal.updateFromServer(null,
                    urlConfigs.email + "SendEmailNow",
                    { emailsId: emailsId },
                    success,
                    error,
                    true,
                    "POST",
                    true);
            }
        });
    }

    function enablePopupMode(result: ScheduledEmailResultVM, e, isNewRow = false) {
        if (e.component.emailsManagement) {
            let allowEdit = true;
            let message = "";
            irGlobal.updateFromServer({},
                urlConfigs.email + "GetEmailDetail",
                {
                    userReportID: e.row.data.id,
                    workbookId: e.row.data.workbookId
                },
                function (returnedData) {
                    allowEdit = returnedData.success;
                    message = returnedData.message;
                    if (allowEdit) {
                        result.usersGroups = returnedData.usersGroups;
                        result.tabs = returnedData.tabs;
                        result.widgets = returnedData.widgets;
                        result.filters = returnedData.filters;

                        let oldEmailsManagement = result.emailsManagement;
                        prepareEmails(result, [returnedData.email], returnedData.tabs, false);
                        result.emailsManagement = oldEmailsManagement;

                        const gridSource = e.component.getDataSource(),
                            gridStore = gridSource.store();

                        gridStore.update(returnedData.id, returnedData);

                        e.component.tabs = returnedData.tabs;
                        e.component.usersGroups = returnedData.usersGroups;
                        e.component.widgets = returnedData.widgets;
                    }
                },
                function (textStatus, errorThrown, errorItem: IError) {
                    errorItem.userMessage = "Failed to get email";
                    irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                },
                true,
                "POST",
                true, undefined, undefined, false);

            if (!allowEdit) {
                DevExpress.ui.dialog.alert(message, "Emails Management");
                return;
            }
        }

        let changes = e.component.option("editing.changes");
        if (!isNewRow) {
            e.component.cancelEditData();
            e.component.option("editing.mode", "popup");

            e.component.option("editing.changes", changes);

            if (!isNewRow) {
                e.component.editRow(e.row.rowIndex);
            }

            e.component.option("editing.popup.onShown", function () {
                var rowChange = changes.find(c => c.key === e.row.key);
                if (rowChange) {
                    Object.keys(rowChange.data).forEach(key => {
                        e.component.cellValue(e.row.rowIndex, key, rowChange.data[key]);
                    });
                }
                changes.splice(changes.indexOf(rowChange), 1);
            });

            e.component.option("editing.popup.onHiding", function () {
                e.component.option("editing.mode", "cell");
                e.component.option("editing.changes", changes);
            });
        }
        else {
            e.component.option("editing.mode", "popup");
            e.component.option("editing.popup.onHiding", function () {
                e.component.option("editing.mode", "cell");
                e.component.option("editing.changes", changes);
            });
        }
    }

    function getFilters(mapping: Mapping, inculdeNoFilter: boolean, currentFilterId: number) {
        if (!mapping) {
            return [];
        }

        let filters = mapping.filters.filter(x => x.id === currentFilterId || x.visibility === VisibilityEnum.Normal);

        if (inculdeNoFilter) {
            return [new FilterTemplate({ id: -1, name: "No Filter" }), ...filters];
        }

        return filters;
    }

    function showNextExecutionDates(email: ScheduledEmail) {
        let o = {
            url: `${urlConfigs.email}GetScheduledOccurrences`,
            data: email,
            dataType: "json",
        } as RequestServerParams
        o.successFunction = function (data) {
            if (data.occurrences) {
                DevExpress.ui.dialog.alert(data.occurrences.replace(/(?:\r\n|\r|\n)/g, "<br><br>"), "Next execution dates");
            }
            else {
                DevExpress.ui.dialog.alert("Unable to calculate next schedule execution dates", "Next execution dates");
            }
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem) {
            errorItem.userMessage = "Failed to get occurrences";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        }

        irGlobal.requestServer(o);
    }

    function getColumnValue(columnName, component) {
        let editRowKey = component.option('editing.editRowKey');
        let index = component.getRowIndexByKey(editRowKey);
        index = index === -1 ? 0 : index;
        return component.cellValue(index, columnName);
    };

    function getAttachmentsOptions(self: IViewModel, result: ScheduledEmailResultVM) {
        const options = [];
        if (!self.currentEmail() || self.currentEmail().attachments === undefined) {
            return options;
        }

        for (let i = 0; i < self.currentEmail().attachments.length; i += 1) {
            options.push(generateNewAttachmentOptions(self, i, result));
        }
        return options;
    }

    function generateNewAttachmentOptions(self: IViewModel, index, result: ScheduledEmailResultVM) {
        let i = index;
        let tabType = undefined;
        let gridInstance = self.dataGridComponent as any;
        if (self.currentEmail().attachments[i].tabId) {
            let tab: ScheduledEmailTabVM = (gridInstance?.tabs || result?.tabs)?.find(x => x.id === self.currentEmail().attachments[i].tabId);
            if (tab) {
                tabType = tab.type;
            }
        }
        return {
            itemType: 'group',
            colCount: 11,
            colSpan: 1,
            items: [
                {
                    dataField: `attachments[${i}].tabId`,
                    label: {
                        text: `Tab`,
                    },
                    cssClass: "scheduledEmail-attachment-label",
                    colSpan: 6,
                    editorType: 'dxSelectBox',
                    editorOptions: {
                        width: 190,
                        indexList: i,
                        value: self.currentEmail().attachments[i].tabId,
                        dataSource: (gridInstance?.tabs || result?.tabs)?.filter(function (x) { return x.id > 0; }) || [],
                        displayExpr: 'name',
                        valueExpr: 'id',
                        onValueChanged: function (e) {
                            let indexList = e.component.option("indexList");
                            self.currentEmail().attachments[indexList].tabId = e.value;

                            let tab: ScheduledEmailTabVM = gridInstance.tabs.find(x => x.id === e.value);
                            let format = self.currentEmail().attachments[indexList].format;
                            let editor = self.dataGridFormEditComponent.getEditor(`attachmentsFormat${indexList}`);
                            if (tab.type === "Dashboard" && (format === EmailFormatEnum.Excel || format === EmailFormatEnum.CSV || format === EmailFormatEnum.ExcelWithoutHeaders || format === EmailFormatEnum.CSVWithoutHeaders)) {
                                if (editor) {
                                    editor.option("value", EmailFormatEnum.PDF);
                                }
                            }

                            if (editor) {
                                editor.option("dataSource", getFormatList(tab.type));
                            }
                        }
                    },
                    isRequired: true,
                    validationRules: [{ type: 'required' }]
                },
                {
                    dataField: `attachments[${i}].format`,
                    label: {
                        text: `Format`,
                        visible: false
                    },
                    colSpan: 3,
                    name: `attachmentsFormat${i}`,
                    editorType: 'dxSelectBox',
                    editorOptions: {
                        width: 135,
                        indexList: i,
                        value: self.currentEmail().attachments[i].format,
                        dataSource: getFormatList(tabType),
                        displayExpr: 'name',
                        valueExpr: 'id',
                        onValueChanged: function (e) {
                            let indexList = e.component.option("indexList");
                            self.currentEmail().attachments[indexList].format = e.value;
                        },
                        itemTemplate: function (data) {
                            let style = "";
                            if (!loggedUser.permissions.printExportPDF() && (data.id === EmailFormatEnum.PDFLandscape || data.id === EmailFormatEnum.PDF) ||
                                !loggedUser.permissions.exportExcelCSV() && (data.id === EmailFormatEnum.Excel || data.id === EmailFormatEnum.CSV || data.id === EmailFormatEnum.ExcelWithoutHeaders || data.id === EmailFormatEnum.CSVWithoutHeaders)) {
                                style = "color: #afadad;";
                            }

                            return `<div style="${style}">${data.name}</div>`;
                        }
                    },
                    validationRules: [{ type: 'required' }]
                },
                {
                    colSpan: 2,
                    itemType: "button",
                    buttonOptions: {
                        text: "X",
                        onClick: function () {
                            self.currentEmail().attachments.splice(i, 1);
                            self.dataGridFormEditComponent.itemOption('attachments-container.attachmentList', 'items', getAttachmentsOptions(self, result));
                            gridInstance.cellValue(gridInstance.getRowIndexByKey(self.currentEmail().id), "attachments", self.currentEmail().attachments);
                        }
                    }
                }
            ]
        }
    }

    function prepareEmails(result: ScheduledEmailResultVM, emails: Array<ScheduledEmail>, workbookTabs: Array<ScheduledEmailTabVM>, showMessage: boolean = true) {
        let tabsRemoved = false;
        for (var i = 0; i < emails.length; i++) {
            let email = emails[i];

            if (result.emailsManagement) {
                if (email.tabId !== 0 && workbookTabs) {
                    if (!workbookTabs.find(t => t.id === email.tabId)) {
                        tabsRemoved = true;
                        break;
                    }
                }

                if (email.attachments) {
                    for (var att = 0; att < email.attachments.length; att++) {
                        if (!workbookTabs.find(t => t.id === email.attachments[att].tabId)) {
                            tabsRemoved = true;
                            break;
                        }
                    }
                }
            }

            if (irSettings.multiTenant && !email.companyId) {
                let companies = result.companies.filter(function (x) { return x.users.includes(email.userId); });
                let company = companies.length > 0 ? companies[0] : null;
                email.companyId = company?.id;
                email.companyName = company?.name;
            }

            if (email.useAddressList) {
                if (email.addressListId > 0) {
                    let addressList = result.addressLists.find(x => x.id === email.addressListId);
                    if (addressList) {
                        if (!addressList.validCompany(email.companyId) || !addressList.validMapping(email.mappingId)) {
                            email.addressListId = null;
                            email.filterId = null;
                        }
                        else {
                            let mappingFilterId = addressList.getFilterId(email.mappingId);
                            if (mappingFilterId) {
                                email.filterId = mappingFilterId;
                            }
                        }
                    }
                }
                else {
                    email.filterId = null;
                }
            }
        }

        if (showMessage && tabsRemoved) {
            DevExpress.ui.notify({
                message: "Some tabs used in the email have been removed. Please save the workbook to use the emails.",
                position: {
                    my: "center top",
                    at: "center top"
                }
            }, "warning", 3000);
            return emails;
        }
    }

    function loadEmailsManagement(emailId: number = null, showEmailLogButton: boolean = true) {
        if (!loggedUser.permissions.emailsManagement()) {
            showToast("User does not have permission to Emails Management");
            return null;
        }

        let result: ScheduledEmailResultVM = new ScheduledEmailResultVM();
        let o = {
            url: urlConfigs.email + "GetEmailsManagement",
            data: emailId === null ? {} : { EmailsId: [emailId] },
            successFunction(data: ScheduledEmailResultVM, e) {
                result = data;
                result.emails = createInstances(ScheduledEmail, result.emails ?? []);
                result.addressLists = createInstances(AddressList, result.addressLists ?? []);
                result.pdfTemplates = createInstances(ScheduledEmailPDFTemplateVM, result.pdfTemplates ?? []);
                result.emailsManagement = true;

                prepareEmails(result, result.emails, [], false);
                
                result.showEmailLogButton = showEmailLogButton;
            },
            failureFunction(textStatus, errorThrown, errorItem) {
                errorItem.userMessage = "Failed to get emails";
                irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
            },
            async: false,
            verb: "POST",
            dataType: "json",
            showIndicator: true
        } as RequestServerParams;

        irGlobal.requestServer(o);

        return result;
    }

    function loadEmails(workbookId: number) {
        let result: ScheduledEmailResultVM = new ScheduledEmailResultVM();
        let o = {
            url: urlConfigs.email + "GetEmails",
            data: { workbookId: workbookId },
            successFunction(data: ScheduledEmailResultVM, e) {
                result = data;
                result.emails = createInstances(ScheduledEmail, result.emails ?? []);
                result.addressLists = createInstances(AddressList, result.addressLists ?? []);
                result.pdfTemplates = createInstances(ScheduledEmailPDFTemplateVM, result.pdfTemplates ?? []);

                prepareEmails(result, result.emails, result.tabs);
            },
            failureFunction(textStatus, errorThrown, errorItem) {
                errorItem.userMessage = "Failed to get emails";
                irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
            },
            async: false,
            verb: "POST",
            dataType: "json",
            showIndicator: true
        } as RequestServerParams;

        irGlobal.requestServer(o);

        return result;
    }

    export function showEmailsFromWorkbook(mappingId: number, workbookId: number, workbookName: string, afterClosed: (result: ScheduledEmailResultVM) => void) {
        showInternal(mappingId, workbookId, workbookName, false, null, false, afterClosed);
    }

    export function show(emailsManagement: boolean, emailId: number = null, showEmailLogButton: boolean = true) {
        showInternal(workbook.workbookConfig.mappingId, workbook.workbookConfig.workbookId(), workbook.workbookConfig.workbookName, emailsManagement, emailId, showEmailLogButton, null);
    }
    
    function showInternal(mappingId: number, workbookId: number, workbookName: string, emailsManagement: boolean, emailId: number, showEmailLogButton: boolean, afterClosed: (result: ScheduledEmailResultVM) => void) {
        if (popupComponent) {
            let element = popupComponent.element();
            popupComponent.dispose();
            element.remove(); 
        }

        let result: ScheduledEmailResultVM = null;
        if (emailsManagement) {
            result = loadEmailsManagement(emailId, showEmailLogButton);
        }
        else {
            result = loadEmails(workbookId);
        }
        result.mappingId = mappingId;
        result.workbookId = workbookId;
        result.workbookName = workbookName;

        let popupOptions = {
            minWidth: 1200,
            width: "90%",
            height: "90%",
            showTitle: true,
            title: emailsManagement ? 'Emails Management' : 'Scheduled Emails',
            visible: false,
            dragEnabled: false,
            hideOnOutsideClick: false,
            showCloseButton: true,
            position: {
                at: "center",
                my: "center",
            },
            onInitialized(e) {
                popupComponent = e.component;
                popupComponent.show();
            },
            onShowing(e) {
                debugger;
                //padding: 2px 10px;
            },
            onHiding() {
                afterClosed?.(result);
            }
        } as DevExpress.ui.dxPopover.Properties;

        let $popover = $(`
            <div data-bind="dxPopup: popupOptions">
                <scheduled-email-editor params="result: result"></scheduled-email-editor>
            </div>`);
        $popover.appendTo('body');

        ko.applyBindings({ popupOptions, result }, $popover[0]);
    }

    function getFormats(scheduledEmail: ScheduledEmail = null, tabs: Array<ScheduledEmailTabVM> = null) {
        let formats = [
            { id: EmailFormatEnum.PDFLandscape, name: "PDF Landscape" },
            { id: EmailFormatEnum.PDF, name: "PDF" },
            { id: EmailFormatEnum.Excel, name: "XLSX" },
            { id: EmailFormatEnum.ExcelWithoutHeaders, name: "Simple XLSX" },
            { id: EmailFormatEnum.CSV, name: "CSV" },
            { id: EmailFormatEnum.CSVWithoutHeaders, name: "Simple CSV" }            
        ];

        if (irSettings.emailBodyHTML) {
            formats.push({ id: EmailFormatEnum.Image, name: "Image" });
            formats.push({ id: EmailFormatEnum.EmailBody, name: "Email Body" });
        }

        return formats;
    }
}